import React, { useState } from 'react';
import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

interface FooterNavLayout3Props {
  colors: {
    background: string;
    text: string;
    activeBackground: string;
    activeText: string;
    icon: string;
  };
}

const FooterNavLayout3: React.FC<FooterNavLayout3Props> = ({ colors }) => {
  const items = [
    { icon: FileText, label: 'History' },
    { icon: CheckSquare, label: 'All Bids' },
    { icon: Home, label: 'Home' },
    { icon: Wallet, label: 'Wallet' },
    { icon: MessageCircle, label: 'Chat' }
  ];

  const [activeIndex, setActiveIndex] = useState<number>(2);

  return (
    <div className="px-3 py-1">
      <div
        className="rounded-2xl shadow-[0_12px_24px_rgba(0,0,0,0.12)] px-6 py-2"
        style={{ backgroundColor: colors.background, border: `1px solid ${colors.background}` }}
      >
        <div className="flex items-center justify-between">
          {items.map((item, index) => {
            const Icon = item.icon;
            const isActive = index === activeIndex;
            return (
              <button
                key={item.label}
                type="button"
                onClick={() => setActiveIndex(index)}
                className="flex flex-col items-center focus:outline-none"
                style={{ background: 'transparent' }}
              >
                <Icon
                  className={`${isActive ? 'w-4 h-4' : 'w-5 h-5'} mb-1`}
                  style={{ color: isActive ? colors.activeText : colors.icon }}
                />
                <span
                  className="text-xs font-medium"
                  style={{ color: isActive ? colors.activeText : colors.text }}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FooterNavLayout3;
